import { useAppDispatch } from "../Hooks/Redux"
import HttpClient from "../HttpClient"
import {toast} from "sonner"
import { setCreateReservation, setError,loading, loadingCountry,setCountry,setErrorCountry} from "../reducers/ApiCreateByidHotel"
import useCartActions from "./useCartActions"

const useReservationCreate =() =>{
    
    const {RemoveCartAll } =useCartActions()

    const dispatch =  useAppDispatch()

    const PostCreateHotel =async({  propertyID,
                                    token,
                                    startDate,
                                    endDate,
                                    guestFirstName,
                                    guestLastName,
                                    guestEmail,
                                    guestPhone,
                                    rooms,
                                    adults,
                                    children,
                                    dateCreated,
                                    number,
                                    exp_month,
                                    exp_year,
                                    cvc,
                                    card_holder,
                                    subtotal,
                                    promoCode}) =>{
        dispatch(loading())
        try {
            const response  = await HttpClient.PostpostReservation({propertyID,
                                                                    token,
                                                                    startDate,
                                                                    endDate,
                                                                    guestFirstName,
                                                                    guestLastName,
                                                                    guestEmail,
                                                                    guestPhone,
                                                                    rooms,
                                                                    adults,
                                                                    children,
                                                                    dateCreated,
                                                                    number,
                                                                    exp_month,
                                                                    exp_year,
                                                                    cvc,
                                                                    card_holder,
                                                                    subtotal,
                                                                    promoCode})
            if(response){
                dispatch(setCreateReservation(response)) 
                RemoveCartAll()
                toast.success(`Exitoso`)
            }else{
                dispatch(setError("no found")) 
                toast.error(`error en el servicio`)
            }
        } catch (error) {
            dispatch(setError("no found")) 
            toast.error(`error en el servicio  ${error}` )
        }
    }


    const PostCreateHotelPse =async({propertyID,
                                    token,
                                    startDate,
                                    endDate,
                                    guestFirstName,
                                    guestLastName,
                                    guestEmail,
                                    guestPhone,
                                    rooms,
                                    adults,
                                    children,
                                    dateCreated,
                                    bank,
                                    subtotal,
                                    promoCode}) =>{
        dispatch(loading())
        try {

           
            const response  = await HttpClient.PostpostReservationPse({propertyID,
                                                                    token,
                                                                    startDate,
                                                                    endDate,
                                                                    guestFirstName,
                                                                    guestLastName,
                                                                    guestEmail,
                                                                    guestPhone,
                                                                    rooms,
                                                                    adults,
                                                                    children,
                                                                    dateCreated,
                                                                    bank,
                                                                    subtotal,
                                                                    promoCode})
           
            if(response){
                dispatch(setCreateReservation(response)) 
                window.location.href = response          
                RemoveCartAll()
                toast.success(`Exitoso`)
            }else{
                dispatch(setError("no found")) 
                toast.error(`error en el servicio`)
            }
        } catch (error) {
            dispatch(setError("no found")) 
            toast.error(`error en el servicio ` )
        }
    }

    const getCountry =async() =>{
        dispatch(loadingCountry())
        try {
            const response  = await HttpClient.GetCountry()
            if(response){
                dispatch(setCountry(response)) 
                toast.success(`Exitoso`)
            }else{
                dispatch(setErrorCountry("no found")) 
                toast.error(`error en el servicio`)
            }
        } catch (error) {
            dispatch(setErrorCountry("no found")) 
            toast.error(`error en el servicio  ${error}` )
        }
    }

    return {
        PostCreateHotel,
        PostCreateHotelPse,
        getCountry
    }

}

export default useReservationCreate